export default {
  bind(el) {
    const dialogHeader = el.querySelector('.el-dialog__header');
    const dragDom = el.querySelector('.el-dialog');
    console.log('bind');
    
    if (!dialogHeader || !dragDom) return;

    // 设置鼠标样式为可拖动
    dialogHeader.style.cursor = 'move';

    // 必须使用 fixed 定位才能自由拖动
    dragDom.style.position = 'fixed';
    dragDom.style.setProperty('transform', 'translate(0,0)', 'important');
    // 重置居中（每次打开弹窗时）
    const resetCenter = (key) => {
      const clientWidth = document.documentElement.clientWidth;
      const clientHeight = document.documentElement.clientHeight;
      const domWidth = dragDom.offsetWidth;
      const domHeight = dragDom.offsetHeight;
      if(key){
        if(key=='top'){
            dragDom.style.top = `${(clientHeight - domHeight) / 2}px`;
        }else{
            dragDom.style.left = `${(clientWidth - domWidth) / 2}px`;
        }
        return;
      }
      dragDom.style.left = `${(clientWidth - domWidth) / 2}px`;
      dragDom.style.top = `${(clientHeight - domHeight) / 2}px`;
    };

    // --- 监听弹窗高度变化 ---
    const resizeObserver = new ResizeObserver(() => {
        // 获取当前屏幕和弹窗尺寸
        resetCenter('top')
        // const clientHeight = document.documentElement.clientHeight;
        // const domRect = dragDom.getBoundingClientRect();
        
        // // 如果弹窗底部超出了屏幕底部
        // if (domRect.bottom > clientHeight) {
        //     // 计算超出的距离
        //     const overflow = domRect.bottom - clientHeight;
        //     // 将弹窗向上移动超出的距离（保留 15px 的底部安全边距）
        //     const currentTop = parseFloat(dragDom.style.top) || domRect.top;
        //     dragDom.style.top = `${currentTop - overflow - 15}px`;
        // }
    });
    // 开始监听弹窗主体
    resizeObserver.observe(dragDom);

    // 将 observer 挂载到元素上，以便在 unbind 时销毁，防止内存泄漏
    el.__resizeObserver__ = resizeObserver;

    // 监听弹窗显示状态，重置位置
    const observer = new MutationObserver(() => {
      if (el.style.display !== 'none') {
        resetCenter();
      }
    });
    observer.observe(el, { attributes: true, attributeFilter: ['style'] });

    const handleMouseDown = (e) => {
        const disX = e.clientX - dragDom.offsetLeft;
        const disY = e.clientY - dragDom.offsetTop;
        const handleMouseMove = (e) => {
            let left = e.clientX - disX;
            let top = e.clientY - disY;

            // 限制不拖出可视区域
            const screenWidth = document.documentElement.clientWidth;
            const screenHeight = document.documentElement.clientHeight;
            const domWidth = dragDom.offsetWidth;
            const domHeight = dragDom.offsetHeight;

            if (left < 0) left = 0;
            if (top < 0) top = 0;
            if (left > screenWidth - domWidth) left = screenWidth - domWidth;
            if (top > screenHeight - domHeight) top = screenHeight - domHeight;

            dragDom.style.left = `${left}px`;
            dragDom.style.top = `${top}px`;
        }
        const handleMouseUp = () =>{
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        }
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    }
    // 鼠标按下事件
    dialogHeader.onmousedown = handleMouseDown;

    // 将清理函数挂载到元素上，以便 unbind 时使用（虽然主要靠 mouseup 清理，但这是双重保险）
    el.__dialogDragCleanup__ = () => {
        dialogHeader.onmousedown = null;
    };
  },
    // 指令与元素解绑时调用（组件销毁时）
    unbind(el) {
      console.log('unbind');
        // 销毁拖拽事件
        if (el.__dialogDragCleanup__) {
            el.__dialogDragCleanup__();
        }
        // 销毁高度监听器
        if (el.__resizeObserver__) {
            el.__resizeObserver__.disconnect();
        }
    }
};